import { render, staticRenderFns } from "./WidgetChart2.vue?vue&type=template&id=4df3dfa0&scoped=true"
import script from "./WidgetChart2.vue?vue&type=script&lang=js"
export * from "./WidgetChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df3dfa0",
  null
  
)

export default component.exports